module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/Angular/Urbanos/src/app/components/cabecera.component.html
// module id = ../../../../../src/app/components/cabecera.component.html
// module chunks = main